import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'
import {
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { mdiDelete, mdiPlus } from '@mdi/js'

import DeviceSelectContainer from '../controls/DeviceSelectContainer'
import SensorSelectContainer from '../controls/SensorSelectContainer'

class TriggerListView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    triggers: PropTypes.array,
    unitId: PropTypes.number,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  }

  static defaultProps = {
    triggers: [],
    unitId: undefined,
  }

  static styles = () => ({
    root: {
      width: 'auto',
      maxWidth: 500,
    },
  })

  state = {
    selectedDeviceId: '',
    selectedSensorId: '',
  }

  onDeviceChange = (deviceId) => {
    this.setState({ selectedDeviceId: deviceId })
  }

  onSensorChange = (sensorId) => {
    this.setState({ selectedSensorId: sensorId })
  }

  onAdd = () => {
    const { selectedDeviceId, selectedSensorId } = this.state

    const trigger = {
      type: 'sensor_value_changed',
      deviceId: selectedDeviceId,
      sensorId: selectedSensorId,
    }
    this.props.onAdd(trigger)
  }

  onRemove = (trigger) => {
    this.props.onRemove(trigger)
  }

  isValidTrigger = () => {
    const { selectedDeviceId, selectedSensorId } = this.state
    return selectedDeviceId && selectedSensorId
  }


  renderRow = (trigger) => (
    <TableRow key={`${trigger.type}-${trigger.deviceId}-${trigger.sensorId}`}>
      <TableCell size="small">
        {trigger.type}
      </TableCell>
      <TableCell size="small">
        {trigger.deviceId}
      </TableCell>
      <TableCell size="small">
        {trigger.sensorId}
      </TableCell>
      <TableCell padding="none">
        <IconButton aria-label="Delete" onClick={() => this.onRemove(trigger)}>
          <SvgIcon>
            <path d={mdiDelete} />
          </SvgIcon>
        </IconButton>
      </TableCell>
    </TableRow>
  )

  render() {
    const { triggers, unitId, classes } = this.props
    const { selectedDeviceId, selectedSensorId } = this.state

    return (
      <Table className={classes.root}>
        <TableHead>
          <TableRow>
            <TableCell size="small">
              Type
            </TableCell>
            <TableCell size="small">
              Device
            </TableCell>
            <TableCell size="small">
              Sensor
            </TableCell>
            <TableCell padding="none" />
          </TableRow>
        </TableHead>
        <TableBody>
          {triggers.map(this.renderRow)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell size="small">
              sensor_value_changed
            </TableCell>
            <TableCell size="small">
              <DeviceSelectContainer
                autoWidth
                unitId={unitId}
                value={selectedDeviceId}
                onChange={this.onDeviceChange}
              />
            </TableCell>
            <TableCell size="small">
              <SensorSelectContainer
                autoWidth
                disabled={!selectedDeviceId}
                deviceId={selectedDeviceId}
                value={selectedSensorId}
                onChange={this.onSensorChange}
              />
            </TableCell>
            <TableCell padding="none">
              <IconButton aria-label="Add" onClick={this.onAdd} disabled={!this.isValidTrigger()}>
                <SvgIcon>
                  <path d={mdiPlus} />
                </SvgIcon>
              </IconButton>
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    )
  }
}

export default withStyles(TriggerListView.styles)(TriggerListView)
